<div class="dialog-content">

    <h2>{{ isEditMode ? 'Modifier' : 'Informations' }} périphérique</h2>

    <form [formGroup]="form" class="device-info">

        <!-- Nom -->
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Nom du périphérique</mat-label>
            <input matInput formControlName="name" />
        </mat-form-field>

        <!-- Site -->
        @if (!isCentrexNg) {
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Site</mat-label>
            <mat-select formControlName="siteName" [compareWith]="compareSite">
                @for (site of availableSites; track site.name) {
                <mat-option [value]="site.name">
                    {{ site.name }}
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
        }

        <!-- Modèle -->
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Modèle</mat-label>
            <input matInput formControlName="modelName" />
        </mat-form-field>

        <!-- Périphérique ID -->
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Périphérique ID</mat-label>
            <input matInput formControlName="address" />
        </mat-form-field>

        <!-- Extension -->
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Extension(s)</mat-label>
            <input matInput formControlName="extensions" />
        </mat-form-field>

        <!-- Statut -->
        <div class="status-field">
            <span class="status-label">Statut</span>

            <div class="status-icon" [class.registered]="form.get('state')?.value === 'registered'"
                [class.unregistered]="form.get('state')?.value !== 'registered'">
                <mat-icon>
                    {{ form.get('state')?.value === 'registered'
                    ? 'check_circle'
                    : 'cancel' }}
                </mat-icon>

                <span class="status-text">
                    {{
                    form.get('state')?.value === 'registered'
                    ? 'Enregistré'
                    : 'Non enregistré'
                    }}
                </span>
            </div>
        </div>
    </form>

    <!-- Historique -->
    @if (!isEditMode) {
    <app-historique [uidObject]="data.device.address" [limit]="5" />
    }

    <!-- Actions -->
    <div class="dialog-actions">
        <button mat-stroked-button class="accent-button" (click)="close()">Fermer</button>
        @if (isEditMode) {
        <button mat-raised-button class="accent-button" (click)="save()" [disabled]="!isFullAccess">
            Valider
        </button>
        }
    </div>
</div>

<ngx-spinner name="spinner" bdColor="rgba(0, 0, 0, 0.2)" size="medium" color="#00D2B4" type="timer"
    [fullScreen]="true"></ngx-spinner>